import React, { Component } from 'react'
import { Form } from 'react-bootstrap';
import Validator from 'validatorjs';

import { FormControl } from '../../../../facturotopia';

class ClienteExternalRegistrationMinimalForm extends Component {

  get rules() {
    return {
      nombre_comercial: ['required', 'string', 'min:2'],
      email: ['required', 'string', 'email'],
      password: ['required', 'string', 'min:8', 'password']
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.props.data,
      ...value
    }

    const validator = this.validate(data);

    this.props.onChange({
      data,
      isValid: validator.passes()
    });
  }

  render() {
    const rules = this.rules;
    const { data = {} } = this.props;

    return (
      <Form autoComplete="off" className="registro">

        <FormControl type="text"
          label="Nombre o razón social"
          name="nombre_comercial"
          placeholder=""
          help=""
          autoFocus={ true }
          rules={ rules.nombre_comercial }
          value={ data.nombre_comercial }
          onChange={ this.handleOnChange }
        />

        <FormControl type="text"
          label="Correo electrónico"
          name="email"
          placeholder="tu-correo@ejemplo.test"
          help=""
          rules={ rules.email }
          value={ data.email }
          onChange={ this.handleOnChange }
        />

        <FormControl type="password"
          label="Contraseña"
          name="password"
          placeholder="Contraseña"
          help="Por seguridad, la contraseña debe contener una mayúscula, un número y un caracter especial ($%&#.?¡@/)"
          rules={ rules.password }
          value={ data.password }
          onChange={ this.handleOnChange }
        />

      </Form>
    )
  }
}

export default ClienteExternalRegistrationMinimalForm;